import { useMemo, useState } from 'react';
import { ConversationTagFilter } from '../types/ConversationTableFilter';
import { canonicalTag } from '../utils/canonicalTag';
import { isTagSelected } from '../utils/isTagSelected';
import { buildTagFilters, getTagFilterId } from '../utils/tagFilterIds';

/**
 * Selected tags for a Tags column filter. Kept apart from the single-select
 * column filters, which replace by filterId.
 */
export const useConversationTagFilters = () => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  // Compared on the canonical form, so clicking a row chip reading `VISA:Egypt`
  // clears the `visa:Egypt` already filtering rather than adding a second
  // filter for the same tag.
  const toggleTag = (tag: string) => {
    setSelectedTags((previous) =>
      isTagSelected(previous, tag)
        ? previous.filter(
            (selected) => canonicalTag(selected) !== canonicalTag(tag)
          )
        : [...previous, tag]
    );
  };

  // One chip per tag, so removing a chip removes exactly that tag.
  const clearTag = (filterId: string) => {
    setSelectedTags((previous) =>
      previous.filter((tag) => getTagFilterId(tag) !== filterId)
    );
  };

  const clearTags = () => setSelectedTags([]);

  const tagFilters: ConversationTagFilter[] = useMemo(
    () => buildTagFilters(selectedTags),
    [selectedTags]
  );

  return { selectedTags, toggleTag, clearTag, clearTags, tagFilters };
};
